export default __webpack_public_path__ + "static/VisibleFooterLogo-9e45936ca6cc2a7ef9f8b19b7fcfd9d8.svg";